import { extend } from "flarum/common/extend";
import VerifiedBadge from "../common/components/VerifiedBadge";

/**
 * Append a verified badge inside the identity h1 of UserCard.
 *
 * Always renders the rich popover (gated only by the `show_tooltip` admin
 * setting). Earlier versions forced `plain` mode inside the
 * `UserCard--popover` hover card to avoid stacking two popovers, but that
 * silently downgraded the badge to a native `title="<tier>"` tooltip even
 * when the admin had the rich popover enabled — visibly inconsistent with
 * every other surface (profile hero, post header, Avocado cards). Letting
 * the popover open inside the hover card stacks visually but functionally
 * matches the configured rule.
 */
export default function addBadgeToUserCard() {
  extend("flarum/forum/components/UserCard", "contentItems", function (items) {
    const user = this.attrs.user;
    if (!user || !user.isVerified || !user.isVerified()) return;
    if (!items.has("identity")) return;
    const identityItem = items.get("identity");
    if (!identityItem) return;
    const badge = m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--card"
    });
    items.setContent("identity", m("h1", {
      className: identityItem.attrs && identityItem.attrs.className || "UserCard-identity"
    }, identityItem.children, " ", badge));
  });
}